<template>
  <v-carousel
    cycle
    :height="height"
    hide-delimiter-background
    show-arrows-on-hover
    class="tw-bg-[#1C1C1C] tw-rounded-md"
  >
    <v-carousel-item
      v-if="!isMobile"
      :src="require('@/assets/images/2ezBanner1.jpg')"
      @click="navigateToGame(`/live-casino`)"
    >
    </v-carousel-item>
    <v-carousel-item
      v-if="!isMobile"
      :src="require('@/assets/images/2ezBanner2.jpg')"
      @click="navigateToGame(`/slots`)"
    >
    </v-carousel-item>
    <v-carousel-item
      v-if="!isMobile"
      :src="require('@/assets/images/2ezBanner3.jpg')"
      @click="navigateToGame(`/slots`, 'Pragmatic Play')"
    >
    </v-carousel-item>

    <v-carousel-item
      v-if="isMobile"
      :src="require('@/assets/images/2ezBanner1Mobile.jpg')"
      @click="navigateToGame(`/live-casino`)"
    >
    </v-carousel-item>
    <v-carousel-item
      v-if="isMobile"
      :src="require('@/assets/images/2ezBanner2Mobile.jpg')"
      @click="navigateToGame(`/slots`)"
    >
    </v-carousel-item>
    <v-carousel-item
      v-if="isMobile"
      :src="require('@/assets/images/2ezBanner3Mobile.jpg')"
      @click="navigateToGame(`/slots`, 'Pragmatic Play')"
    >
    </v-carousel-item>

    <v-carousel-item :src="require('@/assets/images/Casino Roulette.jpg')" @click="navigateToGame(`/live-casino`)">
    </v-carousel-item>
    <v-carousel-item :src="require('@/assets/images/5Games.jpg')" @click="navigateToGame(`/slots`, 'Jili')">
    </v-carousel-item>
    <v-carousel-item
      :src="require('@/assets/images/5-Games.jpg')"
      @click="navigateToGame(`/live-casino`, 'Evolution Asia')"
    >
    </v-carousel-item>
    <v-carousel-item :src="require('@/assets/images/Slots.jpg')" @click="navigateToGame(`/slots`)"> </v-carousel-item>
    <v-carousel-item
      :src="require('@/assets/images/LightningRoulette.jpg')"
      @click="navigateToGame(`/live-casino`, 'Lightning Roulette')"
    >
    </v-carousel-item>
    <v-carousel-item
      :src="require('@/assets/images/Blackjack.jpg')"
      @click="navigateToGame(`/live-casino`, 'blackjack')"
    >
    </v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  data() {
    return {
      isMobile: false,
    };
  },
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  computed: {
    height() {
      return this.isMobile ? "250" : "400";
    },
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth < 1024;
    },
    navigateToGame(link, providers) {
      const currentRoute = this.$route;
      const newRoute = {
        path: link,
        query: { providers },
      };
      if (currentRoute.path === link && currentRoute.query.providers === providers) {
        return;
      }

      this.$nextTick(() => {
        this.$router.push(newRoute).catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            console.error(err);
          }
        });
      });
    },
    gotoEsports(queryLink) {
      let query = queryLink ? "?t=" + queryLink : "";
      const url =
        process.env.VUE_APP_SERVER_ENV == "prod"
          ? process.env.VUE_APP_2EZ_URL || "https://2ez.bet"
          : "http://localhost:8000";
      window.open(url + query);
    },
  },
};
</script>
